export const fontFamilies = [
    {
        id: 1,
        label: 'Sans serif',
        labelKey: 'editor.font.group_sans_serif',
        items: [
            {
                id: 1,
                label: 'Figtree Bold',
                scale: 'scale-[65%]',
                class: 'font-Figtree uppercase font-bold leading-[1.2]',
            },
            {
                id: 2,
                label: 'Figtree Regular',
                scale: 'scale-[70%]',
                class: 'font-Figtree',
            },
            {
                id: 3,
                label: 'Poiret One',
                scale: 'scale-[90%]',
                class: 'font-Poiret-One leading-[1.1]',
            },
            {
                id: 4,
                label: 'Montserrat Bold',
                scale: 'scale-[75%]',
                class: 'font-Montserrat font-bold leading-[1.2]',
            },
            {
                id: 5,
                label: 'Roboto',
                scale: 'scale-[80%]',
                class: 'font-Roboto leading-[1.2]',
            },
            {
                id: 6,
                label: 'Lato Bold',
                scale: 'scale-[75%]',
                class: 'font-Lato font-bold leading-[1.2]',
            },
            {
                id: 7,
                label: 'Raleway',
                scale: 'scale-[80%]',
                class: 'font-Raleway leading-[1.2]',
            },
            {
                id: 8,
                label: 'Open Sans',
                scale: 'scale-[80%]',
                class: 'font-OpenSans-Regular leading-[1.2]',
            },
            {
                id: 9,
                label: 'Inter',
                scale: 'scale-[80%]',
                class: 'font-Inter-Regular leading-[1.2]',
            },
            {
                id: 10,
                label: 'Nunito',
                scale: 'scale-[85%]',
                class: 'font-Nunito leading-[1.2]',
            },
            {
                id: 11,
                label: 'Poppins',
                scale: 'scale-[75%]',
                class: 'font-Poppins leading-[1.2]',
            },
            {
                id: 12,
                label: 'Source Sans Pro',
                scale: 'scale-[80%]',
                class: 'font-Source-Sans-Pro leading-[1.2]',
            },
            {
                id: 13,
                label: 'Work Sans',
                scale: 'scale-[80%]',
                class: 'font-Work-Sans leading-[1.2]',
            },
            {
                id: 14,
                label: 'DM Sans',
                scale: 'scale-[80%]',
                class: 'font-DM-Sans leading-[1.2]',
            },
            {
                id: 15,
                label: 'Manrope',
                scale: 'scale-[80%]',
                class: 'font-Manrope leading-[1.2]',
            },
            {
                id: 16,
                label: 'Outfit',
                scale: 'scale-[80%]',
                class: 'font-Outfit leading-[1.2]',
            },
            {
                id: 17,
                label: 'Ubuntu',
                scale: 'scale-[80%]',
                class: 'font-Ubuntu leading-[1.2]',
            },
            {
                id: 18,
                label: 'Quicksand',
                scale: 'scale-[85%]',
                class: 'font-Quicksand leading-[1.2]',
            },
            {
                id: 19,
                label: 'Josefin Sans',
                scale: 'scale-[80%]',
                class: 'font-Josefin-Sans leading-[1.2]',
            },
        ],
    },
    {
        id: 2,
        label: 'Serif',
        labelKey: 'editor.font.group_serif',
        items: [
            {
                id: 1,
                label: 'Mrs Eaves roman small capital',
                scale: 'scale-100',
                class: 'font-Mrs-eaves',
            },
            {
                id: 2,
                label: 'Narum Myeongjo Regular',
                scale: 'scale-75',
                class: 'font-Nanum-Myeongjo',
            },
            {
                id: 3,
                label: 'Old Standard TT Bold',
                scale: 'scale-[85%]',
                class: 'font-Old-Standard-TT',
            },
            {
                id: 4,
                label: 'Magister',
                scale: 'scale-90',
                class: 'font-Magister',
            },
            {
                id: 5,
                label: 'Playfair Display',
                scale: 'scale-[90%]',
                class: 'font-Playfair-Display leading-[1.2]',
            },
            {
                id: 6,
                label: 'Merriweather',
                scale: 'scale-[85%]',
                class: 'font-Merriweather leading-[1.1]',
            },
            {
                id: 7,
                label: 'Lora',
                scale: 'scale-[90%]',
                class: 'font-Lora leading-[1.1]',
            },
            {
                id: 8,
                label: 'Crimson Text',
                scale: 'scale-[85%]',
                class: 'font-Crimson-Text leading-[1.1]',
            },
            {
                id: 9,
                label: 'Libre Baskerville',
                scale: 'scale-[90%]',
                class: 'font-Libre-Baskerville leading-[1.1]',
            },
            {
                id: 10,
                label: 'Bitter',
                scale: 'scale-[85%]',
                class: 'font-Bitter leading-[1.1]',
            },
            {
                id: 11,
                label: 'PT Serif',
                scale: 'scale-[90%]',
                class: 'font-PT-Serif leading-[1.1]',
            },
            {
                id: 12,
                label: 'Cormorant Garamond',
                scale: 'scale-[90%]',
                class: 'font-Cormorant-Garamond leading-[1.1]',
            },
            {
                id: 13,
                label: 'EB Garamond',
                scale: 'scale-[90%]',
                class: 'font-EB-Garamond leading-[1.1]',
            },
            {
                id: 14,
                label: 'DM Serif Display',
                scale: 'scale-[90%]',
                class: 'font-DM-Serif-Display leading-[1.1]',
            },
            {
                id: 15,
                label: 'Fraunces',
                scale: 'scale-[90%]',
                class: 'font-Fraunces leading-[1.1]',
            },
            {
                id: 16,
                label: 'Noto Serif',
                scale: 'scale-[90%]',
                class: 'font-Noto-Serif leading-[1.1]',
            },
            {
                id: 17,
                label: 'Spectral',
                scale: 'scale-[90%]',
                class: 'font-Spectral leading-[1.1]',
            },
            {
                id: 18,
                label: 'Vollkorn',
                scale: 'scale-[90%]',
                class: 'font-Vollkorn leading-[1.1]',
            },
        ],
    },
    {
        id: 3,
        label: 'Hand drawn',
        labelKey: 'editor.font.group_hand_drawn',
        items: [
            {
                id: 1,
                label: 'Mrs Saint Delafield',
                scale: 'scale-[120%]',
                class: 'font-Mrs-Saint-Delafield leading-[1.4]',
            },
            {
                id: 2,
                label: 'NrDafoe Pro',
                class: 'font-Mr-Dafoe leading-[1]',
            },
            {
                id: 3,
                label: 'Sacramento Regular',
                class: 'font-Sacramento leading-[1]',
            },
            {
                id: 4,
                label: 'Kalam',
                scale: 'scale-[95%]',
                class: 'font-Kalam leading-[1.2]',
            },
            {
                id: 5,
                label: 'Caveat',
                scale: 'scale-[110%]',
                class: 'font-Caveat leading-[1.2]',
            },
            {
                id: 6,
                label: 'Permanent Marker',
                scale: 'scale-[90%]',
                class: 'font-Permanent-Marker leading-[1.1]',
            },
            {
                id: 7,
                label: 'Shadows Into Light',
                scale: 'scale-[100%]',
                class: 'font-Shadows-Into-Light leading-[1.2]',
            },
            {
                id: 8,
                label: 'Dancing Script',
                scale: 'scale-[110%]',
                class: 'font-Dancing-Script leading-[1.2]',
            },
            {
                id: 9,
                label: 'Indie Flower',
                scale: 'scale-[100%]',
                class: 'font-Indie-Flower leading-[1.2]',
            },
            {
                id: 10,
                label: 'Amatic SC',
                scale: 'scale-[95%]',
                class: 'font-Amatic-SC leading-[1.2]',
            },
            {
                id: 11,
                label: 'Comfortaa',
                scale: 'scale-[90%]',
                class: 'font-Comfortaa leading-[1.2]',
            },
            {
                id: 12,
                label: 'Satisfy',
                scale: 'scale-[105%]',
                class: 'font-Satisfy leading-[1.2]',
            },
            {
                id: 13,
                label: 'Pacifico',
                scale: 'scale-[100%]',
                class: 'font-Pacifico leading-[1.2]',
            },
            {
                id: 14,
                label: 'Patrick Hand',
                scale: 'scale-[95%]',
                class: 'font-Patrick-Hand leading-[1.2]',
            },
            {
                id: 15,
                label: 'Gloria Hallelujah',
                scale: 'scale-[100%]',
                class: 'font-Gloria-Hallelujah leading-[1.2]',
            },
            {
                id: 16,
                label: 'Architects Daughter',
                scale: 'scale-[95%]',
                class: 'font-Architects-Daughter leading-[1.2]',
            },
            {
                id: 17,
                label: 'Bad Script',
                scale: 'scale-[100%]',
                class: 'font-Bad-Script leading-[1.2]',
            },
            {
                id: 18,
                label: 'Patrick Hand SC',
                scale: 'scale-[95%]',
                class: 'font-Patrick-Hand-SC leading-[1.2]',
            },
        ],
    },
    {
        id: 4,
        label: 'Display & condensed',
        labelKey: 'editor.font.group_display',
        items: [
            {
                id: 1,
                label: 'Oswald',
                scale: 'scale-[75%]',
                class: 'font-Oswald leading-[1.2]',
            },
            {
                id: 2,
                label: 'Anton',
                scale: 'scale-[70%]',
                class: 'font-Anton leading-[1.2]',
            },
            {
                id: 3,
                label: 'Bebas Neue',
                scale: 'scale-[65%]',
                class: 'font-Bebas-Neue leading-[1.1]',
            },
            {
                id: 4,
                label: 'Archivo Black',
                scale: 'scale-[70%]',
                class: 'font-Archivo-Black leading-[1.2]',
            },
            {
                id: 5,
                label: 'Righteous',
                scale: 'scale-[80%]',
                class: 'font-Righteous leading-[1.2]',
            },
            {
                id: 6,
                label: 'Barlow Condensed',
                scale: 'scale-[80%]',
                class: 'font-Barlow-Condensed leading-[1.2]',
            },
            {
                id: 7,
                label: 'Monoton',
                scale: 'scale-[70%]',
                class: 'font-Monoton leading-[1.1]',
            },
            {
                id: 8,
                label: 'Orbitron',
                scale: 'scale-[75%]',
                class: 'font-Orbitron leading-[1.2]',
            },
            {
                id: 9,
                label: 'Audiowide',
                scale: 'scale-[75%]',
                class: 'font-Audiowide leading-[1.2]',
            },
            {
                id: 10,
                label: 'Black Ops One',
                scale: 'scale-[70%]',
                class: 'font-Black-Ops-One leading-[1.2]',
            },
            {
                id: 11,
                label: 'Teko',
                scale: 'scale-[75%]',
                class: 'font-Teko leading-[1.2]',
            },
            {
                id: 12,
                label: 'Russo One',
                scale: 'scale-[75%]',
                class: 'font-Russo-One leading-[1.2]',
            },
        ],
    },
];

let cachedGroupedFonts = null;

export function getGroupedFonts() {
    if (cachedGroupedFonts) {
        return cachedGroupedFonts;
    }

    const grouped = [];
    fontFamilies.forEach((group) => {
        grouped.push({ label: group.label, labelKey: group.labelKey, group: true, id: group.id, class: group.class });
        group.items.forEach((item) => {
            grouped.push(item);
        });
    });

    cachedGroupedFonts = grouped;
    return cachedGroupedFonts;
}
